import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import _ from 'lodash';
import moment from 'moment-timezone';

import { ReactComponent as CalendarSvg } from '../../../assets/calendar.svg';

import * as api from '../../../api';

import TimeSlots from './TimeSlots';

import { getFormattedDate } from './common';

import styles from '../index.module.css';

interface Props {
  timeSlots: api.EhrTimeSlot.EhrTimeSlot[];
  providerId?: string;
  practiceId: string;
  timezone: string;
  onAppointmentSelected: (appointment: api.EhrTimeSlot.EhrTimeSlot) => void;
  viewMoreAvailability?: JSX.Element;
  modal?: boolean;
  hasAlternateProvider?: boolean;
}

export const Appointments: React.FC<Props> = ({
  timeSlots,
  providerId,
  practiceId,
  timezone,
  onAppointmentSelected,
  viewMoreAvailability,
  modal = false,
  hasAlternateProvider,
}) => {
  const { t } = useTranslation();
  const dayGroup = useMemo(
    () =>
      _.groupBy(
        timeSlots.filter(
          (timeSlot) =>
            timeSlot.providerId === providerId &&
            timeSlot.practiceId === practiceId,
        ),
        (appointment) => {
          return timezone
            ? moment(appointment.startTime).tz(timezone).startOf('day').format()
            : moment(appointment.startTime).startOf('day').format();
        },
      ),
    [timeSlots, timezone, practiceId, providerId],
  );
  const dayGroups = Object.keys(dayGroup);
  const renderContent = (dayTime: string) => (
    <div key={dayTime}>
      <div className={styles.ProviderDateWrapper}>
        <CalendarSvg
          viewBox="0 0 28 24"
          className={styles.ProviderCalendarIcon}
        />
        {getFormattedDate(dayTime, timezone, t)}
      </div>
      <div className={styles.RenderAppointmentDisplay}>
        <TimeSlots
          timeSlots={dayGroup[dayTime]}
          timezone={timezone}
          onAppointmentSelected={onAppointmentSelected}
        />
      </div>
    </div>
  );
  return (
    <>
      {dayGroups.map((dayTime, idx) => {
        return !modal && hasAlternateProvider
          ? idx < 3 && renderContent(dayTime)
          : renderContent(dayTime);
      })}
      {!!viewMoreAvailability && dayGroups.length > 3
        ? viewMoreAvailability
        : null}
    </>
  );
};

export default Appointments;
